import { useState, type FC, useRef } from "preact/compat";
import { useScrollEvent } from "@hooks/useScrollEvents";
import { TestimonialMobile } from "../TestimonialMobile";

export interface TestimonialsProps {
  testimonials: {
    quote: string;
    attributed: string;
    tag: string;
  }[];
}
export const Testimonials: FC<TestimonialsProps> = ({ testimonials }) => {
  const [items] = useState(testimonials);
  const container = useRef<HTMLDivElement>(null);
  const { currentItem, handleClickCurrentItem } = useScrollEvent({
    element: container?.current,
    threshold: 0,
    timeout: 50,
  });
  const handleClick = (index: number) => {
    return () => {
      handleClickCurrentItem(index);
    };
  };
  return (
    <div class="w-full">
      <div class="md:flex flex-col items-center justify-center gap-6 w-full hidden">
        <div ref={container} class="h-full overflow-x-scroll w-full flex">
          {items.map((_testimonial, index) => {
            return (
              <div
                style={{
                  flex: "0 0 100%",
                }}
                class="w-full flex justify-center items-center relative"
                key={index}
              >
                <div class="w-full md:w-2/3 flex-col items-center justify-center">
                  <p class="flex items-center text-center text-base">
                    {`“${_testimonial.quote}”`}
                  </p>
                  <div class="mt-6 flex justify-center">
                    <p class="text-base text-center font-medium">
                      {_testimonial.attributed}
                    </p>
                    &nbsp;
                    <p class="font-normal text-base text-center">
                      {_testimonial.tag}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div class="flex w-[54px] justify-between">
          {items.map((_testimonial, index) => {
            if (index === currentItem) {
              return (
                <div key={index} class="h-2.5 w-2.5 rounded-full bg-gt-lilac" />
              );
            }
            return (
              <button
                aria-label="Next client testimonial"
                class="h-2.5 w-2.5 rounded-full bg-neutral-400"
                onClick={handleClick(index)}
              />
            );
          })}
        </div>
      </div>
      <div className="flex flex-col md:hidden items-center justify-center">
        <TestimonialMobile testimonials={testimonials} />
      </div>
    </div>
  );
};
